<template>
    <footer class="payment-link-footer">
        <div class="footer-content-box">
            <div class="footer-links-wrap">
                <div class="partners">
                    <img src="@/assets/images/pay_methods_branding.png" alt="" />
                    <img src="@/assets/images/logo-nepal-payment-normal.png" alt="" />
                    <img src="@/assets/images/fonepay.png" class="fonepay" alt="" />
                    <img src="@/assets/images/connect_ips.png" class="connect_ips" alt="" />
                </div>
                <div class="footer-logo">
                    <img src="@/assets/images/nic-asia-bank.png" alt="" />
                </div>
            </div>
            <div class="footer-text">
                Powered by NIC Asia Quick Pay
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    name: 'PaymentLinkFooter'
}
</script>